import { useQuery } from '@apollo/client'
import { graphql } from '../../../../gql'
import { ListCampaignsForSidebarQuery } from '../../../../gql/graphql'

const ListCampaignsForSidebar = graphql(`
  query ListCampaignsForSidebar($brands: [ID!]!) {
    campaigns(filter: { brands: $brands }) {
      items {
        id
        title
        kind
        description
        campaignPitch
        pitchHook
        hookStrength
        pitchTopic
        journalistSearchTerms
        rawStr
        createdAt
        updatedAt
      }
    }
  }
`)

export type CampaignList = ListCampaignsForSidebarQuery['campaigns']['items']
export type CampaignListItem = CampaignList[number]

export const useCampaignList = (brandId?: string | null) => {
  return useQuery(ListCampaignsForSidebar, {
    variables: {
      brands: brandId ? [brandId] : []
    },
    fetchPolicy: 'cache-first'
  })
}